import OrderState from '~/constants/common/OrderState';
import {
  useIsLoggedIn,
  useIsUserStateLoaded
} from '~/context/common/UserContext';
import { useGetIsInPipTreatment } from '~/context/home/GlobalContext';
import { useGetUserPurchase } from '~/context/home/UserPurchaseContext';
import Hero from './Hero';
import HeroCards from './HeroCards';
import OrderStatusModule from './OrderStatusModule';
import OrderStatusModuleSkeleton from './OrderStatusModule/OrderStatusModuleSkeleton';

export default function HeroSection() {
  const isInPurchaseInProgressExperiment = useGetIsInPipTreatment();
  const isLoggedIn = useIsLoggedIn();
  const isUserStateLoaded = useIsUserStateLoaded();
  const {
    data: { orderState, vehicle },
    isLoaded
  } = useGetUserPurchase();

  const showSkeleton =
    isInPurchaseInProgressExperiment && (!isLoaded || !isUserStateLoaded);

  const showOrderStatusModule =
    isInPurchaseInProgressExperiment &&
    isLoggedIn &&
    isLoaded &&
    orderState !== OrderState.None &&
    vehicle != null;

  if (showSkeleton) return <OrderStatusModuleSkeleton />;
  if (showOrderStatusModule) return <OrderStatusModule />;

  return (
    <>
      <Hero />
      <HeroCards />
    </>
  );
}
